export const StateName = 'EntityConnectionsState';
export const EntityConnectionStateName = StateName;

export interface EntityConnectionsTableData {
  includeInactive: boolean;
}

export interface EntityConnectionsState {
  entity_connection_tables: {
    [key: string]: EntityConnectionsTableData;
  };
}

export const initialState: EntityConnectionsState = {
  entity_connection_tables: {}
};
